import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=af2d418e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af2d418e')) {
      api.createRecord('af2d418e', component.options)
    } else {
      api.reload('af2d418e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=af2d418e&", function () {
      api.rerender('af2d418e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nvsL5eipehQC/JS/comp/openstreetmap.vue"
export default component.exports